import { MAX_MOBILE_WINDOW_WIDTH, ScreenSize } from '../util/constants';
import { metricsPublisher } from '../util/metrics';
import '../styles/logo.scss';

const createFullSizeLogo = () => {
  const imageLogo = document.createElement('img');
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  imageLogo.setAttribute('src', require('../images/logo.svg').default);
  imageLogo.className = 'brand-registry-header-full-size-logo';
  return imageLogo;
};

const createMobileLogo = () => {
  const imageLogo = document.createElement('div');
  imageLogo.className = 'brand-registry-header-mobile-logo';
  return imageLogo;
};

export const renderLogo = (): HTMLAnchorElement => {
  let screenSize: ScreenSize = window.innerWidth <= MAX_MOBILE_WINDOW_WIDTH ? 'mobile' : 'normal';
  const logo = screenSize === 'normal' ? createFullSizeLogo() : createMobileLogo();

  const logoPublisher = metricsPublisher && metricsPublisher.newChildActionPublisherForMethod('AmazonLogo');

  const logoLink = document.createElement('a');
  logoLink.setAttribute('href', '/');
  logoLink.id = 'brand-registry-header-logo-link';
  logoLink.className = 'brand-registry-header-logo-link';
  logoLink.ariaLabel = 'brand-registry-header-logo';
  logoLink.onclick = () => {
    logoPublisher?.publishCounter('LogoLinkClicked', 1);
  };

  window.addEventListener('resize', () => {
    const newLogoLinkElement = document.getElementById('brand-registry-header-logo-link');

    if (!newLogoLinkElement) {
      throw new Error('Missing parent element for logo');
    }

    const oldChild = newLogoLinkElement.firstChild;

    if (window.innerWidth <= MAX_MOBILE_WINDOW_WIDTH && screenSize === 'normal' && oldChild) {
      screenSize = 'mobile';
      newLogoLinkElement.replaceChild(createMobileLogo(), oldChild);
    } else if (window.innerWidth > MAX_MOBILE_WINDOW_WIDTH && screenSize === 'mobile' && oldChild) {
      screenSize = 'normal';
      newLogoLinkElement.replaceChild(createFullSizeLogo(), oldChild);
    }
  });

  logoLink.appendChild(logo);
  return logoLink;
};
